import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import GridItem from '../../../../kyc/kycPerson/components/GridItem'
import { CollapsibleSection } from '../CollapsibleSection'
import styles from './styles.module.scss'

export const IpAnalysisDetails = ({ vendorData }) => {
  const { t } = useTranslation(['common'])

  if (!vendorData || !vendorData.ip_analysis) {
    return null
  }

  const ipAnalysis = vendorData.ip_analysis

  const summary = `${ipAnalysis.ip_address || 'N/A'} - ${ipAnalysis.ip_country || 'N/A'}, ${ipAnalysis.ip_city || 'N/A'}`

  return (
    <CollapsibleSection title={t('common:ipAnalysisDetails')} summary={summary}>

      <Box className={styles.section}>
        <Typography variant="subtitle1" mb={1} fontWeight={600}>
          {t('common:connectionInformation')}
        </Typography>
        <Box className={styles.gridItems}>
          <GridItem name={t('common:ipAddress')} value={ipAnalysis.ip_address || 'N/A'} />
          <GridItem name={t('common:country')} value={ipAnalysis.ip_country || 'N/A'} />
          <GridItem name={t('common:state')} value={ipAnalysis.ip_state || 'N/A'} />
          <GridItem name={t('common:city')} value={ipAnalysis.ip_city || 'N/A'} />
          <GridItem name={t('common:isp')} value={ipAnalysis.isp || 'N/A'} />
          <GridItem name={t('common:organization')} value={ipAnalysis.organization || 'N/A'} />
          <GridItem name={t('common:timeZone')} value={ipAnalysis.time_zone || 'N/A'} />
        </Box>
      </Box>

      <Box className={styles.section}>
        <Typography variant="subtitle1" mb={1} fontWeight={600}>
          {t('common:deviceInformation')}
        </Typography>
        <Box className={styles.gridItems}>
          <GridItem name={t('common:platform')} value={ipAnalysis.platform || 'N/A'} />
          <GridItem name={t('common:browser')} value={ipAnalysis.browser_family || 'N/A'} />
          <GridItem name={t('common:os')} value={ipAnalysis.os_family || 'N/A'} />
          {ipAnalysis.device_brand && <GridItem name={t('common:deviceBrand')} value={ipAnalysis.device_brand} />}
          {ipAnalysis.device_model && <GridItem name={t('common:deviceModel')} value={ipAnalysis.device_model} />}
        </Box>
      </Box>

      <Box className={styles.section}>
        <Typography variant="subtitle1" mb={1} fontWeight={600}>
          {t('common:securityAnalysis')}
        </Typography>
        <Box className={styles.gridItems}>
          <GridItem name={t('common:vpnTorDetected')} value={ipAnalysis.is_vpn_or_tor ? 'Yes' : 'No'} />
          <GridItem name={t('common:dataCenter')} value={ipAnalysis.is_data_center ? 'Yes' : 'No'} />
          <GridItem name={t('common:status')} value={ipAnalysis.status || 'N/A'} />
        </Box>
      </Box>

      {ipAnalysis.locations_info && (
        <Box className={styles.section}>
          <Typography variant="subtitle1" mb={1} fontWeight={600}>
            {t('common:locationDistanceAnalysis')}
          </Typography>
          {ipAnalysis.locations_info.id_document?.distance_from_ip && (
            <Box className={styles.distanceInfo}>
              <Typography variant="body2">
                {t('common:distanceFromIdDocument')}: <strong>{ipAnalysis.locations_info.id_document.distance_from_ip.distance} km</strong>
                {' '}({ipAnalysis.locations_info.id_document.distance_from_ip.direction})
              </Typography>
            </Box>
          )}
        </Box>
      )}

      {ipAnalysis.warnings && ipAnalysis.warnings.length > 0 && (
        <Box className={styles.warningsSection}>
          <Typography variant="subtitle2" mb={1} color="warning.main">
            Warnings:
          </Typography>
          {ipAnalysis.warnings.map((warning, index) => (
            <Box key={index} className={styles.warningItem}>
              <Typography variant="body2" fontWeight={600}>
                {warning.short_description}
              </Typography>
              <Typography variant="caption" color="textSecondary">
                {warning.long_description}
              </Typography>
            </Box>
          ))}
        </Box>
      )}
    </CollapsibleSection>
  )
}
